"use client";

import {JSX, ReactNode} from "react";

import {SpaceProps, useSectionSpace} from "@/sections/use-section-space";

import {ExpandableTextWithButton} from "@/shared/ui/data-display/expandable-text";
import {HtmlContent} from "@/shared/ui/data-display/html-content";
import {Typography} from "@/shared/ui/data-display/typography";
import {ContainerBase} from "@/shared/ui/layout/container-base";

import "./styles/text-with-form.scss";

export interface TextWithFormProps {
    title: string;
    paragraphs: string;
    space?: SpaceProps;
    children?: ReactNode;
    anchorId?: string;
}

export function TextWithForm({title, paragraphs, space, children, anchorId}: TextWithFormProps): JSX.Element {
    const sectionSpace = useSectionSpace(space);

    return (
        <section className="text-with-form-section" style={sectionSpace} id={anchorId}>
            <ContainerBase>
                <div className="text-with-form-section__grid">
                    <div className="text-with-form-section__text">
                        <Typography as="h2" size={{desktop: 24, mobile: 18}} weight={600}>
                            {title}
                        </Typography>

                        <ExpandableTextWithButton maxLines={12} gap={12} buttonMarginTop={12}>
                            <HtmlContent html={paragraphs} />
                        </ExpandableTextWithButton>
                    </div>

                    {children && <div className="text-with-form-section__form-card">{children}</div>}
                </div>
            </ContainerBase>
        </section>
    );
}
